import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 样式文件需要单独引入
import './common/common.css'
import App from './App'
import router from './router'
import store from './store'
import Enums from './common/enums'
import validate from './common/validate'
import Tool from './common/tool'
import moment from 'moment'
import 'moment/locale/zh-cn'
import apis from './apis'

Vue.use(ElementUI, { size: 'medium' })
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$enums = Enums
Vue.prototype.Tool = Tool
Vue.prototype.$moment = moment
Vue.prototype.$validate = validate
Vue.prototype.$HTTP = apis
Vue.prototype.$isDev = ['test', 'development'].includes(process.env.NODE_ENV)
Vue.config.productionTip = false
Vue.config.errorHandler = function (e, vm, info) {
  Tool.doError(e)
}
router.beforeEach((to, from, next) => {
  if (Tool.checkBrowser()) {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
